import { Box } from '@mui/material'
import Form from '../../form/Form'
import { useAuth } from '../../../context/AuthContext'
import { useLocation } from 'react-router-dom'
import { useEffect, useState, useRef, useMemo } from 'react'
import { editObject } from '../../../api/apiClientCrud'
import { toast } from 'react-toastify'
import useNavigate from '../../hooks/useNavigate'
import { getUserSettingsFields } from './UserFields'

function UserSettings() {
  const location = useLocation()
  const { user } = useAuth()
  const [editUser, setEditUser] = useState(user)
  const [isSubmit, setIsSubmit] = useState(false)
  const toastId = useRef(null)
  const history = useNavigate()

  const options = useMemo(
    () => ({
      fields: getUserSettingsFields(),
      data: editUser,
      location
    }),
    [editUser, location]
  )

  useEffect(() => {
    if (!isSubmit) return

    const updateUserPassword = async () => {
      toastId.current = toast.loading('Enregistrement en cours')

      try {
        const res = await editObject('userPassword', editUser.id, {
          ...editUser,
          lastModBy: editUser.email
        })

        if (res.status === 200) {
          toast.update(toastId.current, {
            type: 'success',
            render: 'Enregistrement terminé',
            autoClose: 2000,
            isLoading: false
          })

          history(location.state?.history || '/', { state: { id: location.state?.id } })
        }
      } catch (error) {
        toast.update(toastId.current, {
          type: 'error',
          render: "Erreur lors de l'enregistrement",
          autoClose: 2000,
          isLoading: false
        })
      } finally {
        setIsSubmit(false)
      }
    }

    updateUserPassword()
  }, [isSubmit, editUser, history, location])

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: 'calc(100vh - 65px)',
        overflowY: 'auto',
        flexGrow: 1
      }}
    >
      <Form options={options} mode='edit' setDataParent={setEditUser} setIsSubmitParent={setIsSubmit} />
    </Box>
  )
}

export default UserSettings
